import React from 'react';
import { Stack, Skeleton } from '@chakra-ui/react';

export const LoadingTable = () => {
    return (
        <Stack py={4}>
            <Skeleton height='40px' />
            <Skeleton height='40px' />
            <Skeleton height='40px' />
        </Stack>
    );
};